import { z } from 'zod';

export const mismatchRequestSchema = z
  .object({
    startTime: z.string(),
    stopTime: z.string(),
  })
  .refine(
    (data) => {
      const start = new Date(data.startTime);
      const stop = new Date(data.stopTime);
      return stop > start;
    },
    {
      message: 'Stop time must be after start time',
      path: ['stopTime'],
    }
  );

export type MisMatchRequestInputs = z.infer<typeof mismatchRequestSchema>;
